import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@drone-js/core';
import { mapStateToProps, DepartureAndReturnModularProps } from 'component/page/detail/MoreInfoSections/DepartureAndReturn/DepartureAndReturn.selectors';
import DepartureCard from 'component/page/detail/MoreInfoSections/DepartureAndReturn/DepartureCard';
import { ActivitiesDepartureReturnContainerSeenEventActivitiesManifestV3 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesDepartureReturnContainerSeenEventActivitiesFieldsV3 } from '@agoda/analytics-messages-definition-activities/events.split';
import { isDepartureAndReturnAvailable } from 'component/page/detail/detailUtils';
import { useInView } from 'react-intersection-observer';

const DepartureAndReturnModular: React.FC<DepartureAndReturnModularProps> = (props) => {
    const isShowDepartureAndReturn = isDepartureAndReturnAvailable(props.logistic, props.isContentReadEnabled);

    const onSeen = (inView: boolean) => {
        if (inView && isShowDepartureAndReturn) {
            trackElementEvent<ActivitiesDepartureReturnContainerSeenEventActivitiesFieldsV3>(ActivitiesDepartureReturnContainerSeenEventActivitiesManifestV3.ids, {
                is_toggle_on: true, // Always true for modular as the analytics is moved to be under the accordion
            });
        }
    };

    const { ref } = useInView({
        threshold: 1,
        triggerOnce: true,
        onChange: onSeen,
    });

    if (!isShowDepartureAndReturn) {
        return null;
    }

    return (
        <Box data-testid="activities-departure-return-info" mb="12" ref={ref}>
            <DepartureCard departureList={props.departurePoints} isDeparture={true} />
            <DepartureCard departureList={props.returnPoints} isDeparture={false} />
        </Box>
    );
};
DepartureAndReturnModular.displayName = 'DepartureAndReturnModular';

export default connect(mapStateToProps)(DepartureAndReturnModular);
